/**
 * Application configuration — single source of truth for env-driven settings.
 * CRA exposes only REACT_APP_* variables at build time.
 */

const ensureTrailingSlash = (url) => (url.endsWith("/") ? url : `${url}/`);

export const API_BASE_URL = ensureTrailingSlash(
  "https://crm-api.inversatechnosoft.com/"
);

// export const API_APP_ID = "wl-inversa-mpwmmpyq";
// export const API_APP_ID = "wl-testbrand-456";
export const API_APP_ID = "WL-14E5E6DC5C07";

/** API path segments (appended to API_BASE_URL). */
export const API_PATHS = {
  PUBLIC_APPS: "api/v1/public/apps/",
  AUTH: "api/v1/auth/",
  PLAYER: "api/v1/player/",
  GAMES: "api/v1/games/",
  // PRIVATE: "api/v1/private/", // reserved for authenticated CRM routes
};

/** Real-time wallet updates; connect with ?token=<player access token>. */
export const BALANCE_WS_URL = `${API_BASE_URL.replace(/^http/, "ws")}ws/balance`;

export const buildApiUrl = (pathSegment) =>
  `${API_BASE_URL}${pathSegment.replace(/^\//, "")}`;
